import * as React from "react";
import classNames from "classnames";

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export default class RowActions extends React.PureComponent<Props> {
  static displayName = "Panel.RowActions";

  render() {
    const children = React.Children.toArray(this.props.children);

    // Since this component is a wrapper for other components, we can't return
    // null if there aren't any children (otherwise React seems to bork).
    // Returning a <noscript> if there's nothing to render seems to do the
    // trick!
    if (children.length > 0) {
      return (
        <div className={classNames("flex items-center", this.props.className)}>
          {this.props.children}
        </div>
      );
    }

    return <noscript />;
  }
}
